import { MouseEvent, ReactNode } from "react";

import {
  EditorElement,
  ParagraphTag,
  PlaceholderData,
} from "@smart/itops-serialisation-basic";

import { Children } from "./children";
import { useParsed } from "../hooks";

type DisplayerProps = {
  paragraphTag?: ParagraphTag;
  hintElement?: ReactNode;
  value?: string | null;
  fallback?: string;
  disableLinks?: boolean;
  placeholderData?: Partial<PlaceholderData>;
  onPlaceholderClick?: (
    e: MouseEvent<HTMLSpanElement>,
    element: EditorElement<"placeholder">,
  ) => void;
};

const Displayer = ({
  paragraphTag,
  hintElement,
  value,
  fallback,
  disableLinks,
  placeholderData,
  onPlaceholderClick,
}: DisplayerProps) => {
  const parsed = useParsed(value?.trim() || fallback);
  return parsed ? (
    <Children
      paragraphTag={paragraphTag}
      hintElement={hintElement}
      items={parsed}
      disableLinks={disableLinks}
      placeholderData={placeholderData}
      onPlaceholderClick={onPlaceholderClick}
    />
  ) : null;
};

export { Displayer, DisplayerProps };
